import { CurrencyDollarIcon } from '@heroicons/react/24/outline';
import { useCoinStore } from '../../../stores/coinStore';
import { useModelStore } from '../../../stores/modelStore';
import { ModelType, Resolution } from '@packages/global';

interface CoinPriceDisplayProps {
  modelId: string;
  duration?: number;
  resolution?: Resolution;
  className?: string;
}

export default function CoinPriceDisplay({ modelId, duration, resolution, className = '' }: CoinPriceDisplayProps) {
  const { account } = useCoinStore();
  const { getModelById } = useModelStore();

  const selectedModel = getModelById(modelId);
  const baseCoinPrice = selectedModel?.coinPrice || 0;
  const isAudioBilling = selectedModel?.modelType === ModelType.IMAGE_TO_VIDEO
    && Boolean(selectedModel.requiredInputs?.includes('audio'));

  // 音频计费 provider：显示单价，不预估总价
  if (isAudioBilling) {
    if (baseCoinPrice === 0) return null;
    return (
      <div className={`flex items-center gap-1.5 px-2 py-1 text-xs rounded-lg border bg-bg-elevated text-gray-400 border-border-default ${className}`}>
        <CurrencyDollarIcon className="w-3.5 h-3.5" />
        <span>{baseCoinPrice} 剧点/秒</span>
      </div>
    );
  }

  // 普通计费：coinPrice × duration × resolutionMultiplier
  const supportedDurations = selectedModel?.supportedDurations ?? [];
  const effectiveDuration = supportedDurations.length > 0 ? (duration ?? 5) : 5;
  const resolutionMultiplier = resolution === Resolution.FHD_1080P ? 2 : 1;
  const coinPrice = baseCoinPrice * effectiveDuration * resolutionMultiplier;

  const hasEnoughCoins = (account?.balance ?? 0) >= coinPrice;

  if (coinPrice === 0) return null;

  return (
    <div className={`flex items-center gap-1.5 px-2 py-1 text-xs rounded-lg border ${hasEnoughCoins
      ? 'bg-bg-elevated text-gray-400 border-border-default'
      : 'bg-red-900/20 text-red-400 border-red-700/50'
      } ${className}`}>
      <CurrencyDollarIcon className="w-3.5 h-3.5" />
      <span>{coinPrice}</span>
    </div>
  );
}
